import { FC, ReactElement } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { Bets } from '../../config/bets';
import { useCrashAutoplaySlice } from '../../store/slices/crashAutoplay/selectors';
import { GameBetButtonConnected } from '../GameBetButton';

import styles from './FloatingBetControls.module.css';

interface FloatingBetStatusProps {
  betCode: Bets;
  isAutocashEnabled: boolean;
  isAutoPlayEnabled: boolean;
  hideAutoPlayAutoCashout: boolean;
  isInfiniteAutoPlayEnabled: boolean;
  cashoutMultiplier: string;
}
export const FloatingBetStatus: FC<FloatingBetStatusProps> = ({
  betCode,
  isAutocashEnabled,
  isAutoPlayEnabled,
  hideAutoPlayAutoCashout,
  isInfiniteAutoPlayEnabled,
  cashoutMultiplier,
}): ReactElement => {
  const mods = useModifiers(styles, 'floating_autoplay_autocashout_block', {
    transform: hideAutoPlayAutoCashout,
  });
  const autoPlayRounds = useCrashAutoplaySlice.getRemainingCount(betCode);
  const infiniteAutoPlay = isInfiniteAutoPlayEnabled ? <L10nText tk="ON" /> : ' ' + autoPlayRounds;

  return (
    <div className={styles.floating_bet_status_block}>
      <div className={styles.floating_game_bet_button_block}>
        <GameBetButtonConnected betCode={betCode} isFloatingButton={true} />
      </div>
      <div className={`${styles.floating_autoplay_autocashout_block} ${mods}`}>
        <p className={styles.status_text}>
          <L10nText tk="AUTOPLAY" />:{isAutoPlayEnabled ? infiniteAutoPlay : <L10nText tk="OFF" />}
        </p>
        <p className={styles.status_text}>
          <L10nText tk="AUTO_CASHOUT" />: <L10nText tk={isAutocashEnabled ? cashoutMultiplier + 'x' : 'OFF'} />
        </p>
      </div>
    </div>
  );
};
